import CrossSellGalleryElement from './CrossSellGalleryElement';
import CrossSellGalleryElementDefinition from './CrossSellGalleryElementDefinition';
import CrossSellGalleryElementMetaData from './CrossSellGalleryElementMetaData';

export default {
  CrossSellGalleryElement: CrossSellGalleryElement,
  CrossSellGalleryElementDefinition: CrossSellGalleryElementDefinition,
  CrossSellGalleryElementType: CrossSellGalleryElementMetaData.type,
};
